import { RateAdjustments } from "../RateAdjustments";
import { DataSource, Label, Layout, Panel, Step, Stepper, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRateAdjustmentStepper extends Layout {
    expireStep: Step;
    labelNewLane: Label;
    labelSelectedCount: Label;
    labelT: Label;
    layoutRateAdjustments: RateAdjustments;
    layoutRateAdjustmentsStep2: RateAdjustments;
    panelEffectiveDate: Panel;
    panelSelected: Panel;
    saveStep: Step;
    sourceExpireRates: DataSource;
    sourceNewRates: DataSource;
    stepperRateAdjustment: Stepper;
    textboxNewEffectiveDate: Textbox;
}
